if (!customElements.get('personalised-review-how-modal')) {
  customElements.define('personalised-review-how-modal', class extends HTMLElement {
    constructor() {
      super();
      this.isVisible = false;
      this.closeButton = null;
      this.gotItButton = null;
      this.overlay = null;
    }

    connectedCallback() {
      this.closeButton = this.querySelector('.personalised-review-how-modal__close');
      this.gotItButton = this.querySelector('.personalised-review-how-modal__got-it');
      this.overlay = this.querySelector('.personalised-review-how-modal__overlay');
      this.dialog = this.querySelector('.personalised-review-how-modal__dialog');

      // Apply correct content block based on reco state.
      // Replaces the inline script previously used on each page template.
      // --has-reco block defaults to display:none in HTML; --no-reco defaults visible.
      this._applyRecoContent();

      // Setup event listeners for opening the modal
      document.querySelector('.personalised-review-how-it-works-btn')?.addEventListener('click', () => this.show());

      // Setup event listeners for closing the modal
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.hide());
      }

      if (this.gotItButton) {
        this.gotItButton.addEventListener('click', () => this.hide());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', (event) => {
          if (event.target === this.overlay) {
            this.hide();
          }
        });
      }

      // Handle escape key
      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && this.isVisible) {
          this.hide();
        }
      });
    }

    show() {
      this.isVisible = true;
      this.hidden = false;
      this.setFocus();
    }

    hide() {
      this.isVisible = false;
      this.hidden = true;
      this.restoreFocus();
    }

    setFocus() {
      // Store the element that had focus before opening the modal
      this.previouslyFocused = document.activeElement;
      
      // Set focus to the first focusable element in the modal
      const focusable = this.dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusable.length) {
        focusable[0].focus();
      }

      // Trap focus within modal - bind to this instance
      this.handleTabKeyBound = this.handleTabKey.bind(this);
      this.dialog.addEventListener('keydown', this.handleTabKeyBound);
    }

    restoreFocus() {
      // Remove focus trap
      if (this.handleTabKeyBound) {
        this.dialog.removeEventListener('keydown', this.handleTabKeyBound);
      }
      
      // Restore focus to the previous element
      if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
        this.previouslyFocused.focus();
      }
    }

    handleTabKey(event) {
      if (event.key !== 'Tab') return;

      const focusable = this.dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      
      const firstFocusable = focusable[0];
      const lastFocusable = focusable[focusable.length - 1];

      if (event.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          event.preventDefault();
        }
      }
    }

    _applyRecoContent() {
      var hasReco = window.personalised &&
                    window.personalised.userState &&
                    window.personalised.userState.hasReco;
      var hasRecoEl = this.querySelector('.personalised-review-how-modal__features--has-reco');
      var noRecoEl  = this.querySelector('.personalised-review-how-modal__features--no-reco');
      if (hasRecoEl) hasRecoEl.style.display = hasReco ? '' : 'none';
      if (noRecoEl)  noRecoEl.style.display  = hasReco ? 'none' : '';
    }
  });
}
